import { Button } from '#client/components/ui/Button';
import { TextField } from '#client/components/ui/TextField';
import { type DateRange, PRESETS } from './useDateRange';

/**
 * The period picker shared by the income, profit-and-loss and expense screens.
 *
 * Two native date inputs plus three presets. Native rather than a custom
 * calendar: `<input type="date">` gets the platform's own picker, its keyboard
 * handling and its locale for free, and a finance screen is not where to spend
 * a bespoke widget's worth of bugs.
 */
export function DateRangeBar({ range }: { range: DateRange }) {
  return (
    <div className="c-range-bar">
      <TextField
        label="From"
        type="date"
        value={range.from}
        // The end date is clamped to the start rather than validated after the
        // fact: an inverted range is not an error worth a message, it is a state
        // the control should not be able to reach.
        max={range.to}
        onChange={(event) => range.setRange(event.target.value, range.to)}
      />
      <TextField
        label="To"
        type="date"
        value={range.to}
        min={range.from}
        onChange={(event) => range.setRange(range.from, event.target.value)}
      />

      <div className="c-range-bar__presets">
        {PRESETS.map((preset) => (
          <Button
            key={preset.label}
            variant="secondary"
            size="sm"
            onClick={() => {
              const next = preset.range();
              range.setRange(next.from, next.to);
            }}
          >
            {preset.label}
          </Button>
        ))}
      </div>
    </div>
  );
}
